/*
  Smooth scroll back to the buy box for the in-page CTAs.

  These buttons carry href="#", which jumps instantly and leaves a "#" on the
  URL. Native scroll-behavior: smooth is an option but its duration is fixed by
  the browser and reads slow over a long page, so the tween is driven here:
  easeInOutCubic, 450ms, shortened on short trips so a nearby button does not
  feel sluggish. Cancelled the moment the visitor scrolls themselves.
*/
(() => {
  if (window.__pawpayaScrollTop) return;

  const MAX_MS = 450;
  const MIN_MS = 220;
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let frame = null;
  const stop = () => {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = null;
    window.removeEventListener('wheel', stop);
    window.removeEventListener('touchstart', stop);
    window.removeEventListener('keydown', stop);
  };

  function scrollToY(to, onDone) {
    const start = window.scrollY || document.documentElement.scrollTop || 0;
    const delta = to - start;
    if (Math.abs(delta) < 2) {
      if (onDone) onDone();
      return;
    }
    stop();
    if (reduced()) {
      window.scrollTo(0, to);
      if (onDone) onDone();
      return;
    }
    const duration = Math.max(MIN_MS, Math.min(MAX_MS, Math.abs(delta) * 0.6));
    let t0 = null;
    const step = (ts) => {
      if (t0 === null) t0 = ts;
      const p = Math.min(1, (ts - t0) / duration);
      window.scrollTo(0, Math.round(start + delta * ease(p)));
      frame = p < 1 ? requestAnimationFrame(step) : null;
      if (frame === null) {
        stop();
        if (onDone) onDone();
      }
    };
    // let the visitor take over at any point
    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchstart', stop, { passive: true, once: true });
    window.addEventListener('keydown', stop, { once: true });
    frame = requestAnimationFrame(step);
  }

  const scrollToTop = () => scrollToY(0);
  window.__pawpayaScrollTop = scrollToTop;

  /* The rating eyebrow above the product title points at the reviews section
     further down the page. Same easing and same take-over-on-touch behaviour as
     the buttons that come back up, so the two feel like one gesture. */
  function scrollToAnchor(hash) {
    const target = document.querySelector(hash);
    if (!target) return false;
    const wanted = () => {
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      return Math.max(0, window.scrollY + target.getBoundingClientRect().top - margin);
    };
    /* Lazy images above the target finish loading during the tween and push it
       further down the page, so the trip lands short — 78px short on the home
       page. Re-measure once the tween ends and close the gap. */
    const settle = () => {
      if (frame !== null) return; // the visitor took over; leave them where they are
      const gap = wanted() - (window.scrollY || 0);
      if (Math.abs(gap) > 4) scrollToY(wanted());
    };
    scrollToY(wanted(), () => setTimeout(settle, 60));
    return true;
  }

  // Delegated so it survives the section re-render on every variant change.
  const SELECTOR = '.gs-split__foot .gs-cta, .gs-banner__cta, .gs-5050__cta';
  document.addEventListener('click', (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const el = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
    if (!el) return;
    // A button pointed somewhere real should still go there.
    const href = el.getAttribute('href');
    if (href && href !== '#') return;
    event.preventDefault();
    scrollToTop();
  });

  document.addEventListener('click', (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
    if (!link) return;
    const hash = link.getAttribute('href');
    if (!hash || hash === '#' || hash.length < 2) return;
    if (!scrollToAnchor(hash)) return;
    event.preventDefault();
    // keep the anchor in the URL without letting the browser jump to it
    if (history.replaceState) history.replaceState(null, '', hash);
  });
})();
